<template>
  <div>
      <h3 class="ma-2">Projects I have worked on:</h3>
      <v-row>
        <v-col
            v-for="project in projects"
            :key="project.name"
            cols="12"
            md="4">
                <Project :project="project" />
        </v-col>
      </v-row>
  </div>
</template>

<script>
import Project from '@/components/Project.vue'

export default {
    components: {
        Project,
    },
    data: () => ({ 
        projects: [
            {
                name: 'Viruscomplete',
                date: 'Fall 2020',
                descriptions: [
                    'My bachelors thesis, still work in progress, consisting of fullstack development',
                    'The project was made for JYVSECTEC with the idea of easing out employee strain during cyber exercises.',
                    'The subject of the thesis was to develope a fullstack web application.',
                ],
                technologies: [
                    'VueJS',
                    'NestJS (NodeJS MVC framework)',
                    'Postgresql',
                ],
                links: [
                ],
            },
            {
                name: 'Cyber Exercise Planning System',
                date: 'Summer 2020',
                descriptions: [
                    'As a part of training at JYVSECTEC we (4 trainees) were tasked to recreate existing web application with modern web technologies.',
                    'My part in the development of the application was creating CRUD queries and frontend with VueJS.',
                ],
                technologies: [
                    'VueJS',
                    'GraphQL',
                    'Hasura (GraphQL engine)',
                    'PostgreSQL',
                ],
                links: [
                ],
            },
            {
                name: 'Stranded',
                date: 'Spring 2020',
                descriptions: [
                    'Topdown shooter created by Team Rogue as a part of game development course.',
                    'Team Rogue consisted of game designer, graphics designer and three programmers.',
                    'My part in the project was that of a manager although I took part in developing UI, enemies and playercharacter. I also handled most of the communications between the stakeholders.',
                ],
                technologies: [
                    'PhaserJS',
                    'Javascript',
                ],
                links: [
                    {
                        name: 'Source',
                        url: 'https://gitlab.labranet.jamk.fi/team-rogue/game',
                    },
                    {
                        name: 'Demo',
                        url: 'https://student.labranet.jamk.fi/~L4721/stranded/',
                    },
                    {
                        name: 'Trailer',
                        url: 'https://www.youtube.com/watch?v=gpRYlPqu-pg&feature=youtu.be',
                    },
                    {
                        name: 'Documentation',
                        url: 'https://gitlab.labranet.jamk.fi/team-rogue/documentation',
                    }
                ],
            },
            {
                name: 'AWS Chatbot PoC',
                date: 'Fall 2019 - Spring 2020',
                descriptions: [
                    'The project was an innovative PoC of a chatbot, made for Qvantel, which at the end of the project turned into MVP.',
                    'The work consisted of working with agile techniques and innovating through each iteration. So to put it bluntly, we set out to do something and the end result was completely different.',
                    'My part was creating logging solution, researching AWS Lex and creating simple API for logging errors.',
                ],
                technologies: [
                    'React',
                    'AWS Lambda',
                    'AWS Lex',
                    'AWS API Gateway',
                ],
                links: [
                    {
                        name: 'Team',
                        url: 'http://vices.pages.labranet.jamk.fi/site/',
                    },
                    {
                        name: 'Course Page',
                        url: 'http://ttos1000-ttos1200.pages.labranet.jamk.fi/amk-2019/',
                    }
                ],
            },
            {
                name: 'TACS',
                date: 'Summer 2019',
                descriptions: [
                    'TACS (Tactical Airsoft Command System) was one of the challenges presented to WimmaLab 2019. The 8 member team Overflow, in which I was in, took the challenge.',
                    'The aim of the project was to create player tracking and command system with replay for Ehasa ry (East Helsinki Airsoft Association)',
                    'My part in the project was developing backend of the system.',
                ],
                technologies: [
                    'React',
                    'React Native',
                    'NestJS (NodeJS MVC framework)',
                    'Robotframework',
                    'Docker',
                    'PostgreSQL',
                ], 
                links: [
                    {
                        name: 'WimmaLab',
                        url: 'https://www.wimmalab.org/',
                    },
                    {
                        name: 'Source',
                        url: 'https://gitlab.labranet.jamk.fi/wimma-lab-2019/overflow',
                    },
                ],
            },
            {
                name: 'Wear Right',
                date: 'Spring 2019',
                descriptions: [
                    'The aim of this project was to create PoC of an web application that suggests clothing based on the current weather.',
                    'My part in this project was to get CMS (Content Management System) up and running. I also researched and setted up simple testautomation with Robotframework',
                ],
                technologies: [
                    'AngularJS',
                    'Lumen (php framework)',
                    'Cockpit (CMS)',
                    'MySQL',
                    'Robotframework',
                ],
                links: [
                    {
                        name: 'Source',
                        url: 'https://gitlab.labranet.jamk.fi/team-e-2019',
                    },
                    {
                        name: 'Video',
                        url: 'https://www.youtube.com/watch?v=n3GWsXsjhTs&feature=youtu.be',
                    },
                    {
                        name: 'Team',
                        url: 'http://team-e-2019.pages.labranet.jamk.fi/site/',
                    },
                ],
            },
            {
                name: 'Dynamo Dungeon',
                date: 'Fall 2018',
                descriptions: [
                    'Small scale first person shooter created as a pair work with Mikko Martikainen',
                    'We combined 3 different courses work in a single project while thinking out of the box. The courses covered the areas of algorithms and data structures, web-programming and web server programming.',
                ],
                technologies: [
                    'Unity (JS and C#)',
                    'MySQL',
                    'PHP',
                ],
                links: [
                    {
                        name: 'Source',
                        url: 'https://gitlab.labranet.jamk.fi/L4721/dynamo-dungeon',
                    },
                ],
            },
            {
                name: 'Dynamon Kuumalinja',
                date: 'Spring 2018',
                descriptions: [
                    'Simple chat with the emphasis on UI. This project was done as a pair with Mikko Martikainen.',
                    'What we learned that this is not the way to create chat application. Instead of the frontend sending queries on a set interval, the queries should be done when a websocket or an event launches. Never the less creating the project was a learning experience.',
                ],
                technologies: [
                    'C#',
                    'MySQL',
                ],
                links: [
                    {
                        name: 'Source',
                        url: 'https://gitlab.labranet.jamk.fi/L4721/Dynamon-kuumalinja',
                    },
                    {
                        name: 'Documentation',
                        url: 'https://gitlab.labranet.jamk.fi/L4721/Dynamon-kuumalinja/-/wikis/home',
                    },
                ],
            },
        ],
    }),
}
</script>

<style>

</style>